module.exports = __webpack_public_path__ + "media/images/area/feature/kansai/related/zh-hant/3-60b1907f2ae49ec0570a7977aa7b6a0a.jpg";